import dynamic from 'next/dynamic';

const SearchFormCDynamicDefault = dynamic(() => import('./default'), {
	ssr: false,
});

export default SearchFormCDynamicDefault;
